// extracted by mini-css-extract-plugin
module.exports = {"products__wrapper":"product-wrapper_products__wrapper__MzDcA"};